export default __webpack_public_path__ + "static/media/dimensions.b1c9d57c.png";